import classNames from 'classnames';
import React from 'react';
import styles from './inputGroupOutlet.module.scss';
import InputOutlet from 'components/inputOutlet';
interface IInputOutletProps extends React.HTMLProps<HTMLInputElement> {
  label: string;
  required?: boolean;
  errors?: string;
  name: string;
  touched?: boolean;
  secondaryTitle?: string;
  disabled?: boolean;
  value: string;
  optionValue: string;
  Options: Array<IOption>;
  setOptionValue: (e: string) => void;
}
const InputGroupOutlet = ({
  label,
  required = false,
  errors,
  touched,
  Options,
  name,
  value,
  optionValue,
  secondaryTitle,
  disabled,
  setOptionValue,
  ...props
}: IInputOutletProps) => {
  return (
    <>
      <div className={styles['input-group-outlet']}>
        <InputOutlet
          label={label}
          name={name}
          required={required}
          value={value}
          disabled={disabled}
          {...props}
          errors={errors}
          touched={touched}
        />
        <span
          className={classNames(
            styles['input-group-outlet__secondaryTitle'],
            'color-gray-2',
          )}
        >
          {secondaryTitle}
        </span>
        <select
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
            setOptionValue(e.target.value)
          }
          value={optionValue}
          defaultValue={optionValue}
        >
          {React.Children.toArray(
            Options.map(item => (
              <option value={item.value}> {item.label} </option>
            )),
          )}
        </select>
      </div>
    </>
  );
};

export default InputGroupOutlet;
